import * as Yup from "yup";
import { appIntl } from "../../../i18n/IntlGlobalProvider";

export const PromotionDialogSchema = Yup.object().shape({
  promotitle: Yup.string().required(
    appIntl().formatMessage({ id: "mandatoryField" })
  ),

  claimlimit: Yup.string().when("promotype", ([promotype], schema) => {
    return promotype !== "viewonly"
      ? schema.required(appIntl().formatMessage({ id: "mandatoryField" }))
      : schema.notRequired();
  }),
  free: Yup.string().when("promotype", ([promotype], schema) => {
    return promotype !== "viewonly"
      ? schema.required(appIntl().formatMessage({ id: "mandatoryField" }))
      : schema.notRequired();
  }),

  companylist: Yup.array().when("promotype", ([promotype], schema) => {
    return promotype !== "viewonly"
      ? schema
          .min(1, appIntl().formatMessage({ id: "mandatoryField" }))
          .required(appIntl().formatMessage({ id: "mandatoryField" }))
      : schema.notRequired();
  }),
  freecreditjson: Yup.object().shape({
    freedemandnum: Yup.string().when("$promotype", ([promotype], schema) => {
      return promotype === "freecredit"
        ? schema.required(appIntl().formatMessage({ id: "mandatoryField" }))
        : schema.notRequired();
    }),
  }),

  promotype: Yup.string().required(),
});
